export const BriefPage = ({ kicker, title, footer, pageNumber, children }) => (
  <section className="wq-page">
    <div className="wq-bar" />
    <div className="wq-in">
      <div className="wq-brand">
        Win<span>IQ</span>
      </div>
      <div className="wq-kicker">{kicker}</div>
      <h1 className="wq-title">{title}</h1>
      {children}
    </div>
    <div className="wq-foot">
      <span>{footer}</span>
      <span>{pageNumber}</span>
    </div>
  </section>
);
